import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWarning } from '@fortawesome/free-solid-svg-icons';
import { FormInputText } from '../../formInputsV2/FormInputText';
import { FormInputCheckbox } from '../../formInputsV2/FormInputCheckbox';
// import { FastQuoteLoading } from '../../components/elements/FastQuoteLoading';
import { FastQuoteLoading } from '../../componentsV2/elements/FastQuoteLoading';
import { Label } from '../../formInputsV2/styles/common';
import { FormInputSelect } from '../../formInputsV2/FormInputSelect';
import {
  adr, flagResponse, km_during_one_year, months, provenienza, usoAutocarro, vehicle_plate_types, vehiclesAmountInFamily, years,
} from '../../constants';
import FormReactSelectBrand from '../../formInputsV2/FormReactSelectBrand';
import FormReactSelectModel from '../../formInputsV2/FormReactSelectModel';
import InputSelectTable from '../../componentsV2/inputs/InputTable';
import { FormInputNumber } from '../../formInputsV2/FormInputNumber';
import getAllowedPurchaseYears from '../../helpers/getAllowedPurchaseYears';
import { FormInputRadio } from '../../formInputsV2/FormInputRadio';
import { FormInputPrice } from '../../formInputsV2/FormInputPrice';
import { FormLayout } from '../../formInputsV2/FormLayout.styles';
import CollapsiblePanel from '../../formInputsV2/CollapsiblePanel';
import { WarningButton, WarningHint } from '../../formInputsV2/Button.styles';
import { WarningAlert } from '../../formInputsV2/Alert.styles';

function RcVanStepOne({
  errors, answers, updateFormData, isValid, checkBoxTypeAutocarro, isLoadingFastQuote, register, brands, isLoadingVehicleModels, vehicleModels, isLoadingVehicleVersions, vehicleVersions, formData, vehicleActivities,
  showStepOneFields = false,
  setShowStepOneFields = () => {},
}) {
  return (
    <>
      <FormLayout>
        <div id="vehiclePlateDiv">
          <FormInputText
            label="Targa dell' autocarro"
            placeholder="Inserisci la targa"
            error={answers.is_old_plate !== '2' ? errors.vehicle_plate?.message : undefined}
            onChange={(value) => updateFormData({ vehicle_plate: value.toUpperCase() })}
            value={answers.vehicle_plate}
            valid={isValid('vehicle_plate')}
          />
          {errors.vehicle_plate?.message && answers.is_old_plate !== '2' && (
            <div className="mt-2 d-flex align-items-center justify-content-center flex-column">
              <WarningButton
                type="button"
                className="btn btn-warning btn-sm"
                onClick={() => updateFormData({
                  complete_manually: true,
                  is_old_plate: '2',
                })}
              >
                <FontAwesomeIcon icon={faWarning} />
                {' '}
                Forza Targa (Formato Non Standard)
              </WarningButton>
              <WarningHint>
                Usa il pulsante qui sopra solo se la targa ha un formato non standard.
              </WarningHint>
            </div>
          )}
          {answers.is_old_plate === '2' && (
            <WarningAlert className="alert alert-warning">
              <FontAwesomeIcon icon={faWarning} />
              <span>
                <strong>Targa forzata:</strong>
                {' '}
                Stai utilizzando una targa con formato non standard.
              </span>
            </WarningAlert>
          )}
        </div>

        <FormInputSelect
          registration={register('is_old_plate')}
          error={errors.is_old_plate?.message}
          valid={isValid('is_old_plate')}
          placeholder="-Tipo-"
          options={vehicle_plate_types}
          label="Tipo di Targa"
          onChange={(e) => {
            const value = e.target.value;
            if (value === '2') {
              updateFormData({
                is_old_plate: value,
                complete_manually: true,
              });
            }
          }}
        />

        {(isValid('vehicle_plate') === true || answers.is_old_plate === '2')
          && (
            <div className="d-flex justify-content-center align-items-center gap-2 gap-md-5" ref={checkBoxTypeAutocarro} id="checkBoxType">

              <FormInputCheckbox
                label=" Veicolo già assicurato?"
                checked={answers.renew_check}
                onChange={() => updateFormData({
                  renew_check: !answers.renew_check,
                  insurance_type: !answers.renew_check ? 'B' : '',
                  new_risks_check: false,
                  complete_manually: answers.is_old_plate === '2',
                })}
              />

              <FormInputCheckbox
                label=" Nuovo rischio?"
                checked={answers.new_risks_check}
                onChange={() => updateFormData({
                  new_risks_check: !answers.new_risks_check,
                  renew_check: false,
                  insurance_type: !answers.new_risks_check ? 'N' : '',
                  complete_manually: answers.is_old_plate === '2',
                })}
              />
            </div>
          )}

      </FormLayout>

      {isLoadingFastQuote === true && <FastQuoteLoading />}

      {answers.vehicle_plate !== ''
        && (!errors.vehicle_plate?.message || answers.is_old_plate === '2')
        && (answers.renew_check || answers.new_risks_check)
        && (answers.imm_vehicle_month !== ''
          || answers.complete_manually === true) && (
          <FormLayout id="nextInputsImmatricolationBrand">
            <div className="row mt-2">
              <Label as="span">Data di prima immatricolazione</Label>
              <div className="col-12 col-md-8">
                <FormInputSelect
                  registration={register('imm_vehicle_month')}
                  error={errors.imm_vehicle_month?.message}
                  valid={isValid('imm_vehicle_month')}
                  placeholder="-Mese-"
                  options={months}
                />
              </div>

              <div className="col-12 col-md-4">
                <FormInputSelect
                  registration={register('imm_vehicle_year')}
                  error={errors.imm_vehicle_year?.message}
                  valid={isValid('imm_vehicle_year')}
                  placeholder="-Anno-"
                  options={years}
                />
              </div>
            </div>

            <FormReactSelectBrand
              label="Marca"
              values={{
                vehicle_brand_code: answers.vehicle_brand_code,
              }}
              error={errors.vehicle_brand_code?.message}
              valid={isValid('vehicle_brand_code')}
              onChange={(item) => updateFormData({
                vehicle_brand_code: item.vehicle_brand_code,
              })}
              options={brands}
            />
          </FormLayout>
      )}

      {answers.imm_vehicle_year ? (
        <>
          {answers.vehicle_brand_code && (
            <FormLayout id="nextInputModel">
              {isLoadingVehicleModels ? (
                <p className="text-center">Attendere prego...</p>
              ) : (
                <FormReactSelectModel
                  label="Modello"
                  values={{
                    vehicle_model_code: answers.vehicle_model_code,
                  }}
                  error={errors.vehicle_model_code?.message}
                  valid={isValid('vehicle_model_code')}
                  onChange={(item) => updateFormData({
                    vehicle_model_code: item.vehicle_model_code,
                  })}
                  options={vehicleModels}
                />
              )}
            </FormLayout>
          )}
          {answers.vehicle_brand_code && answers.vehicle_model_code ? (
            isLoadingVehicleVersions ? (
              <p className="text-center">Attendere prego...</p>
            ) : answers.vehicle_model_code
              && vehicleVersions.length > 0 ? (
                <FormLayout id="versionCode">
                  <InputSelectTable
                    TableHeader={(
                      <div className="d-flex">
                        <div className="col-7">Descrizione</div>
                        <div className="col-1">CC</div>
                        <div className="col-4">Data Veicolo</div>
                      </div>
                  )}
                    label="Versione"
                    name="vehicle_version_code"
                    id="vehicle_version_code"
                    options={vehicleVersions}
                    selected={answers.vehicle_am_code}
                    error={errors.vehicle_version_code?.message}
                    valid={isValid('vehicle_version_code')}
                    onSelectOption={(value) => updateFormData({
                      vehicle_version_code: value.id,
                      vehicle_am_code: value.am_code,
                    })}
                  />
                </FormLayout>
              ) : (
                <div className="alert-general-error">
                  Nessuna versione trovata per questo modello!
                </div>
              )
          ) : ('')}

          {answers.vehicle_version_code && (
            <FormLayout id="restInputsStepOne">
              <hr />
              <CollapsiblePanel
                open={showStepOneFields}
                onToggle={() => setShowStepOneFields(!showStepOneFields)}
                openLabel="Detagli"
                closedLabel="Detagli"
              >
                <FormInputNumber
                  registration={register('weight')}
                  error={errors.weight?.message}
                  valid={isValid('weight')}
                  label="Peso dell'auto"
                  placeholder="Inserisci il peso in kg"
                />
                <FormInputNumber
                  registration={register('power')}
                  error={errors.power?.message}
                  valid={isValid('power')}
                  label="Potenza in kW"
                  placeholder="Inserisci la potenza in kW"
                />
                <FormInputSelect
                  label="Altra alimentazione"
                  registration={register('other_power_supply')}
                  error={errors.other_power_supply?.message}
                  valid={isValid('other_power_supply')}
                  placeholder="-Seleziona-"
                  options={formData.vehicle_fuels}
                />
                <FormInputSelect
                  label="Parcheggio auto"
                  registration={register('vehicle_parking')}
                  error={errors.vehicle_parking?.message}
                  valid={isValid('vehicle_parking')}
                  placeholder="-Seleziona-"
                  options={formData.parking_types}
                />
                <FormInputSelect
                  label="Antifurto"
                  registration={register('theft_protection_code')}
                  error={errors.theft_protection_code?.message}
                  valid={isValid('theft_protection_code')}
                  placeholder="-Seleziona-"
                  options={formData.theft_protections}
                />
                <FormInputSelect
                  label="Utilizzo"
                  registration={register('vehicle_usage')}
                  error={errors.vehicle_usage?.message}
                  valid={isValid('vehicle_usage')}
                  placeholder="-Seleziona-"
                  options={formData.vehicle_usage_types.filter((type) => type.vehicle_type === 'auto')}
                />

                <FormInputSelect
                  label="Km percorsi in un anno"
                  registration={register('predicted_km')}
                  error={errors.predicted_km?.message}
                  valid={isValid('predicted_km')}
                  placeholder="-Seleziona-"
                  options={km_during_one_year}
                />
                <FormInputSelect
                  label="Auto nel nucleo familiare"
                  registration={register('vehicles_owned')}
                  error={errors.vehicles_owned?.message}
                  valid={isValid('vehicles_owned')}
                  placeholder="-Seleziona-"
                  options={vehiclesAmountInFamily}
                />
                <FormInputRadio
                  name="tow_hook"
                  label="Hai montato il gancio di traino?"
                  paragraph="(iscritta a rimorchiatori, caravan, ecc.)"
                  options={flagResponse}
                  registration={register('tow_hook')}
                  error={errors.tow_hook?.message}
                />
              </CollapsiblePanel>

              <FormInputSelect
                label="Settore di attività"
                placeholder="-Seleziona-"
                options={vehicleActivities}
                registration={register('vehicle_activity')}
                valid={isValid('vehicle_activity')}
                error={errors.vehicle_activity?.message}
              />
              <FormInputNumber
                registration={register('massa_com')}
                error={errors.massa_com?.message}
                valid={isValid('massa_com')}
                min={0}
                max={440}
                label="Massa Complesiva (0-440)"
                placeholder="Inserisci la massa complessiva"
              />

              <FormInputSelect
                label="Provenienza"
                placeholder="-Seleziona-"
                options={provenienza}
                registration={register('provenienza')}
                valid={isValid('provenienza')}
                error={errors.provenienza?.message}
              />
              <FormInputSelect
                label="ADR"
                placeholder="-Seleziona-"
                options={adr}
                registration={register('adr')}
                valid={isValid('adr')}
                error={errors.adr?.message}
              />
              <FormInputSelect
                label="Uso Veicolo"
                placeholder="-Seleziona-"
                options={usoAutocarro}
                registration={register('uso_autocarro')}
                valid={isValid('uso_autocarro')}
                error={errors.uso_autocarro?.message}
              />
              {answers.imm_vehicle_year !== '' && (
                <div className="row mt-2">
                  <Label as="span">Mese e anno in cui hai comprato l'auto</Label>
                  <div className="col-12 col-md-8">
                    <FormInputSelect
                      registration={register('vehicle_purchased_month')}
                      error={errors.vehicle_purchased_month?.message}
                      valid={isValid('vehicle_purchased_month')}
                      placeholder="-Mese-"
                      options={months}
                    />
                  </div>

                  <div className="col-12 col-md-4">
                    <FormInputSelect
                      registration={register('vehicle_purchased_year')}
                      error={errors.vehicle_purchased_year?.message}
                      valid={isValid('vehicle_purchased_year')}
                      placeholder="-Anno-"
                      options={getAllowedPurchaseYears(
                        answers.imm_vehicle_year,
                      )}
                    />
                  </div>
                  <div className="col-12">
                    <FormInputPrice
                      label="Valore del veicolo"
                      onChange={(value) => updateFormData({
                        vehicle_value: value,
                      })}
                      value={answers.vehicle_value}
                      error={errors.vehicle_value?.message}
                      valid={isValid('vehicle_value')}
                      placeholder="Valore del veicolo"
                    />
                  </div>
                </div>
              )}

              <FormInputRadio
                label="Peso a carico del veicolo supera i 35 Quintali?"
                options={flagResponse}
                name="is_heavy"
                registration={register('is_heavy')}
                error={errors.is_heavy?.message}
              />
            </FormLayout>
          )}
        </>
      ) : (
        ''
      )}
    </>
  );
}

export default RcVanStepOne;
